const baseName = 'react-select'

export const isRequiredClassName = ({isRequired, value}) =>
    isRequired &&
    (value === null ||
        typeof value === 'undefined' ||
        (typeof value === 'string' && value.length === 0) ||
        (Array.isArray(value) && value.keys() === 0) ||
        (typeof value === 'object' && Object.keys(value).length === 0))
        ? 'required'
        : ''

export const componentClassName = (isOutlined) =>
    `${baseName}-component ${baseName}-component${isOutlined ? '--outline' : '--box'}`

export const CLASSNAME = `${baseName}-container`
export const CLASSNAME_PREFIX = `${baseName}`
